import { useContext } from 'react';

import type { TruncationMode } from '@dynatrace/strato-components/typography';

import { FormatterContext } from '../context/FormatterContext.js';

export const useTruncationMode = (): TruncationMode => {
  return useContext(FormatterContext)?.truncationMode;
};
